import React from 'react'

export const Circle_Container = ({randomColor}) => {

  return (
    <div className="circles-container">
        <p className="text-center">5 Circles</p>
        <div className="circle" id="circle-1" style={{backgroundColor:randomColor[0]}}>1</div>
        <div className="circle" id="circle-2" style={{backgroundColor:randomColor[1]}}>2</div>
        <div className="circle" id="circle-3" style={{backgroundColor:randomColor[2]}}>3</div>
        <div className="circle" id="circle-4" style={{backgroundColor:randomColor[3]}}>4</div>
        <div className="circle" id="circle-5" style={{backgroundColor:randomColor[4]}}>5</div>
      </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Circle-Container.jsx